const formatCelular = (celular) => {
  if (celular) {
    return celular.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  return celular;
};

export default formatCelular;
